import { render, staticRenderFns } from "./BotMessage.vue?vue&type=template&id=533dcf44&scoped=true&"
import script from "./BotMessage.vue?vue&type=script&lang=js&"
export * from "./BotMessage.vue?vue&type=script&lang=js&"
import style0 from "./BotMessage.vue?vue&type=style&index=0&id=533dcf44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533dcf44",
  null
  
)

export default component.exports